/*
 * @Author: Girish Akhare
 * @Date: 2022-01-21 10:48:06
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-03-09 15:34:30
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomProgressModule } from '../progress/custom-progress.module';

import { CustomDndFileComponent } from './dnd-file.component';
import { DndDirective } from './dnd-file.directive';

@NgModule({
  imports: [CommonModule, FormsModule, CustomProgressModule],
  exports: [CustomDndFileComponent],
  declarations: [CustomDndFileComponent, DndDirective],
  providers: []
})
export class CustomDndFileModule {}
